import { fail } from '@datapad/utilities';
import { SchemaFactory, Tree } from 'fluid-framework';
import { CalendarEvent } from './calendar/index.js';
import { Campaign } from './Campaign.js';
import { Character } from './Character.js';
import { User } from './User.js';
const schemaFactory = new SchemaFactory('datapad.app');
export class CampaignsMap extends schemaFactory.map('campaigns-map', Campaign) {
}
export class UsersMap extends schemaFactory.map('users-map', User) {
}
export class CalendarEventsMap extends schemaFactory.map('calendar-events-map', CalendarEvent) {
}
export class CharactersMap extends schemaFactory.map('characters-map', [Character]) {
}
export class Datapad extends schemaFactory.object('datapad', {
    campaigns: CampaignsMap,
    users: UsersMap,
    calendarEvents: CalendarEventsMap,
    characters: CharactersMap,
}) {
    getCharacter(characterOrRef) {
        return Tree.is(characterOrRef, Character)
            ? characterOrRef
            : (this.characters.get(characterOrRef.id) ??
                fail(`Character with ID "${characterOrRef.id}" not found.`));
    }
    getUser(userOrRef) {
        return Tree.is(userOrRef, User)
            ? userOrRef
            : (this.users.get(userOrRef.id) ?? fail(`User with ID "${userOrRef.id}" not found.`));
    }
    getUserByName(userName) {
        return [...this.users.values()].find((user) => user.userName === userName);
    }
    getCampaign(campaignOrRef) {
        return Tree.is(campaignOrRef, Campaign)
            ? campaignOrRef
            : (this.campaigns.get(campaignOrRef.id) ??
                fail(`Campaign with ID "${campaignOrRef.id}" not found.`));
    }
    getAllCharacters() {
        const characters = [...this.characters.values()];
        return characters.sort((a, b) => a.name.localeCompare(b.name));
    }
    getPlayersCharacters(player) {
        const characters = player.characters.map((ref) => this.getCharacter(ref));
        return characters.sort((a, b) => a.name.localeCompare(b.name));
    }
    deleteCharacter(characterOrRef) {
        this.characters.delete(characterOrRef.id);
    }
    deleteEvent(eventOrRef) {
        this.calendarEvents.delete(eventOrRef.id);
    }
    deletePlayer(playerOrRef) {
        this.users.delete(playerOrRef.id);
    }
    deleteCampaign(campaignOrRef) {
        this.campaigns.delete(campaignOrRef.id);
    }
}
//# sourceMappingURL=Datapad.js.map